import { render } from "./ImageHeader.vue?vue&type=template&id=eb606722&scoped=true"
import script from "./ImageHeader.vue?vue&type=script&lang=js"
export * from "./ImageHeader.vue?vue&type=script&lang=js"

import "./ImageHeader.vue?vue&type=style&index=0&id=eb606722&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb606722"]])

export default __exports__